import { mapGetters } from "vuex";
import pointageService from "@/services/pointage";
import profileService from "@/services/profile";
var platform = require('platform');

export default {
  data() {
    return {
      support: {
        reason: undefined,
        title: null,
        message: null
      },
      profile: undefined,
      isSubmitting: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
    device() {
      return platform.description.split('on')[1]
    },
    browser() {
      return platform.description.split('on')[0]
    },
  },
  async created() {
    await this.getChargePlanning();
    await this.getLastestScan();
  },
  methods: {
    async getLastestScan() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()
      const date = today.getDate()
      let start, end;
      if (date > 10) {
        start = new Date(year, month, 1, 0, 0, 0).getTime();
        end = new Date(year, month + 1, 0, 23, 59, 59).getTime();
      } else {
        start = new Date(year, month - 1, 1, 0, 0, 0).getTime();
        end = new Date(year, month, date, 23, 59, 59).getTime();
      }
      try {
        const { data } = await pointageService.getLastestScan(start, end)
        this.pointings = data
      } catch (error) {
        this.pointings = [];
      }
    },
    getChargePlanning() {
      const vue = this;
      profileService
        .getChargePlanning()
        .then(function (response) {
          if (response.success) {
            vue.profile = response.data;
          }
        })
    },
    resetData() {
      this.support = {
        reason: undefined,
        title: undefined,
        message: undefined
      }
    }
  },
};
